import Spouse from 'src/value-objects/Spouse';
import * as moment from 'moment';
import { Moment } from 'moment';

interface InitialData {
  userId: number;
  // tslint:disable-next-line:no-any
  [key: string]: any;
}

export default class JuridicalPersonData {
  id?: number;
  name?: string;
  surname?: string;
  nationality?: string;
  idNumber?: string;
  idExpirationDate?: Moment;
  idFront?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string
  };
  idBack?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string
  };
  birthDate?: Moment;
  phoneNumber?: string;
  notificationEmail?: string;
  email?: string;
  address?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  country?: string;
  maritalStatus?: string;
  maritalEconomicStatus?: string;
  maritalPropertyRegime?: string;
  occupationType?: string;
  occupation?: string;
  company?: string;
  spouse?: Spouse;
  profilePicture?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string
  };
  facebookProfile?: string;
  twitterProfile?: string;
  linkedinProfile?: string;
  defaultInvestorProfile?: boolean;
  enterpriseName?: string;
  officeAddress?: string;
  establishmentDate?: Moment;
  notaryName?: string;
  notaryAddress?: string;
  protocolNumber?: string;
  cifNumber?: string;
  provinceCommercialRegister?: string;
  corporateEmail?: string;
  volumeNumber?: string;
  pageNumber?: string;
  sheetNumber?: string;
  companyProxy?: string;
  companyProxyIncluded?: boolean;
  establishmentRepresentativeDate?: Moment;
  provinceDeed?: string;
  notaryProxyName?: string;
  protocolProxyNumber?: string;
  cifDocument?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  deedCompany?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  companyStatutes?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  realOwnership?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  idRepresentatives?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  notarialDeed?: {
    url: string,
    encoded?: string,
    ext?: string,
    name?: string,
  };
  userId: number;
  personType: string;
  isPublicProfile?: boolean;

  constructor(entity: InitialData) {
    this.id = entity.id;
    this.name = entity.name;
    this.surname = entity.surname;
    this.nationality = entity.nationality;
    this.idNumber = entity.idNumber;
    this.idExpirationDate = entity.idExpirationDate ? moment.utc(entity.idExpirationDate) : undefined;
    this.idFront = typeof entity.idFront === 'object' ? entity.idFront : { url: entity.idFront };
    this.idBack = typeof entity.idBack === 'object' ? entity.idBack : { url: entity.idBack };
    this.birthDate = entity.birthDate ? moment.utc(entity.birthDate) : undefined;
    this.phoneNumber = entity.phoneNumber;
    this.notificationEmail = entity.notificationEmail;
    this.email = entity.email;
    this.address = entity.address;
    this.houseNumber = entity.houseNumber;
    this.zipCode = entity.zipCode;
    this.city = entity.city;
    this.province = entity.province;
    this.country = entity.country;
    this.maritalStatus = entity.maritalStatus;
    this.maritalEconomicStatus = entity.maritalEconomicStatus;
    this.maritalPropertyRegime = entity.maritalPropertyRegime;
    this.occupationType = entity.occupationType;
    this.occupation = entity.occupation;
    this.company = entity.company;
    this.spouse = entity.spouse ? new Spouse(entity.spouse) : undefined;
    this.profilePicture = typeof entity.profilePicture === 'object' ?
      entity.profilePicture :
      { url: entity.profilePicture };
    this.facebookProfile = entity.facebookProfile;
    this.twitterProfile = entity.twitterProfile;
    this.linkedinProfile = entity.linkedinProfile;
    this.defaultInvestorProfile = entity.defaultInvestorProfile || false;
    this.enterpriseName = entity.enterpriseName;
    this.officeAddress = entity.officeAddress;
    this.establishmentDate = entity.establishmentDate ? moment.utc(entity.establishmentDate) : undefined;
    this.notaryName = entity.notaryName;
    this.notaryAddress = entity.notaryAddress;
    this.protocolNumber = entity.protocolNumber;
    this.cifNumber = entity.cifNumber;
    this.provinceCommercialRegister = entity.provinceCommercialRegister;
    this.corporateEmail = entity.corporateEmail;
    this.volumeNumber = entity.volumeNumber;
    this.pageNumber = entity.pageNumber;
    this.sheetNumber = entity.sheetNumber;
    this.companyProxy = entity.companyProxy;
    this.companyProxyIncluded = entity.companyProxyIncluded || false;
    this.establishmentRepresentativeDate = entity.establishmentRepresentativeDate ?
      moment.utc(entity.establishmentRepresentativeDate) : undefined;
    this.provinceDeed = entity.provinceDeed;
    this.notaryProxyName = entity.notaryProxyName;
    this.protocolProxyNumber = entity.protocolProxyNumber;
    this.cifDocument = typeof entity.cifDocument === 'object' ? entity.cifDocument : { url: entity.cifDocument };
    this.deedCompany = typeof entity.deedCompany === 'object' ? entity.deedCompany : { url: entity.deedCompany };
    this.companyStatutes = typeof entity.companyStatutes === 'object' ?
      entity.companyStatutes :
      { url: entity.companyStatutes };
    this.realOwnership = typeof entity.realOwnership === 'object' ?
      entity.realOwnership :
      { url: entity.realOwnership };
    this.idRepresentatives = typeof entity.idRepresentatives === 'object' ?
      entity.idRepresentatives :
      { url: entity.idRepresentatives };
    this.notarialDeed = typeof entity.notarialDeed === 'object' ? entity.notarialDeed : { url: entity.notarialDeed };
    this.userId = entity.userId;
    this.personType = entity.personType;
    this.isPublicProfile = entity.isPublicProfile || false;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/JuridicalPersonData.tsx